/* eslint-disable @typescript-eslint/ban-ts-comment */
import type { GetStaticProps, NextPage } from 'next';
import { useTranslation } from 'next-i18next';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import Link from 'next/link';
import React from 'react';
import { fetchBlogPosts } from 'src/actions/blogActions';
import { searchForAllCountriesStaticProps } from 'src/actions/searchActions';
import { DocumentSummary } from 'src/components/document/summary.component';
import { PageLayout } from 'src/components/layout/pageLayout.component';
import { appConfig } from 'src/config';
import type { DataWorldChartTypes } from 'src/types/types';
import type { BlogPage } from '../../types/blogPage';

interface BlogProps {
  posts: BlogPage[];
  countries: DataWorldChartTypes[];
}

const Blog: NextPage<BlogProps> = ({ posts, countries }) => {
  const { t } = useTranslation(['blog']);

  return (
    <PageLayout
      title={t('blog:seo.title')}
      description={t('blog:seo.description')}
      bannerTitle={`${appConfig.brand.appName} founder's thoughts`}
      subtitle={`Updates, thoughts, and reflections from the Population Project team`}
      hasTitleBanner
      fullWidth
      countries={countries}
    >
      {posts.map((post, index) => {
        return (
          <Link
            key={post.attributes.slug}
            href={`/founders-thoughts/${post.attributes.slug}`}
            className={index > 0 ? 'mt-4 border-t border-gray-200' : undefined}
          >
            <DocumentSummary
              className="mx-auto max-w-5xl px-2"
              document={post}
            />
          </Link>
        );
      })}
    </PageLayout>
  );
};

export default Blog;

// @ts-ignore
export const getStaticProps: GetStaticProps<BlogProps> = async ({
  locale,
}: {
  locale: string;
}) => {
  const blogPosts = await fetchBlogPosts();

  // const firstPosts: { id: number }[] = [];
  // const lastPosts: { id: number }[] = [];

  const countries = await searchForAllCountriesStaticProps();

  if (!blogPosts || !countries) {
    throw new Error('Error fetching blog posts or countries');
  }

  // blogPosts?.data.forEach((post: { id: number }) => {
  //   if (post?.id > 26) {
  //     firstPosts?.push(post);
  //   } else {
  //     lastPosts?.push(post);
  //   }
  // });

  // const sortedBlogPosts = firstPosts?.reverse().concat(lastPosts);

  return {
    props: {
      ...(await serverSideTranslations(locale || 'en', [
        'common',
        'about',
        'partners',
        'navbar',
        'new-homepage',
        'new-navbar',
        'new-footer',
        'blog',
      ])),
      posts: blogPosts.data,
      countries: countries,
    },
    revalidate: 3600,
  };
};
